/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AidModelCalculationDto,
  AidModelCalculationRequest,
  CalculationRuleDto,
  CalculationRuleRequest,
  CeebCodesValidationRequest,
  CeebCodesValidationResponse,
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType, BodyType } from '../../orval-mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Updates an existing calculation for the aid model
 * @summary Update calculation
 */
export const updateCalculation = (
  oktaUserId: string,
  modelId: number,
  id: number,
  aidModelCalculationRequest: BodyType<AidModelCalculationRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelCalculationDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/calculations/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: aidModelCalculationRequest,
      signal,
    },
    options
  );
};

export const getUpdateCalculationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCalculation>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      id: number;
      data: BodyType<AidModelCalculationRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCalculation>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    id: number;
    data: BodyType<AidModelCalculationRequest>;
  },
  TContext
> => {
  const mutationKey = ['updateCalculation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCalculation>>,
    {
      oktaUserId: string;
      modelId: number;
      id: number;
      data: BodyType<AidModelCalculationRequest>;
    }
  > = (props) => {
    const { oktaUserId, modelId, id, data } = props ?? {};

    return updateCalculation(oktaUserId, modelId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCalculationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCalculation>>
>;
export type UpdateCalculationMutationBody =
  BodyType<AidModelCalculationRequest>;
export type UpdateCalculationMutationError = ErrorType<unknown>;

/**
 * @summary Update calculation
 */
export const useUpdateCalculation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCalculation>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        id: number;
        data: BodyType<AidModelCalculationRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateCalculation>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    id: number;
    data: BodyType<AidModelCalculationRequest>;
  },
  TContext
> => {
  return useMutation(getUpdateCalculationMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Updates an existing rule
 * @summary Update rule
 */
export const updateRule = (
  oktaUserId: string,
  modelId: number,
  calculationId: number,
  id: number,
  calculationRuleRequest: BodyType<CalculationRuleRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CalculationRuleDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/calculations/${calculationId}/rules/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: calculationRuleRequest,
      signal,
    },
    options
  );
};

export const getUpdateRuleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRule>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      calculationId: number;
      id: number;
      data: BodyType<CalculationRuleRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRule>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    calculationId: number;
    id: number;
    data: BodyType<CalculationRuleRequest>;
  },
  TContext
> => {
  const mutationKey = ['updateRule'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRule>>,
    {
      oktaUserId: string;
      modelId: number;
      calculationId: number;
      id: number;
      data: BodyType<CalculationRuleRequest>;
    }
  > = (props) => {
    const { oktaUserId, modelId, calculationId, id, data } = props ?? {};

    return updateRule(
      oktaUserId,
      modelId,
      calculationId,
      id,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRule>>
>;
export type UpdateRuleMutationBody = BodyType<CalculationRuleRequest>;
export type UpdateRuleMutationError = ErrorType<unknown>;

/**
 * @summary Update rule
 */
export const useUpdateRule = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRule>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        calculationId: number;
        id: number;
        data: BodyType<CalculationRuleRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateRule>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    calculationId: number;
    id: number;
    data: BodyType<CalculationRuleRequest>;
  },
  TContext
> => {
  return useMutation(getUpdateRuleMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Deletes a rule by ID
 * @summary Delete rule
 */
export const deleteRule = (
  oktaUserId: string,
  modelId: number,
  calculationId: number,
  id: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<void>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/calculations/${calculationId}/rules/${id}`,
      method: 'DELETE',
      signal,
    },
    options
  );
};

export const getDeleteRuleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteRule>>,
    TError,
    { oktaUserId: string; modelId: number; calculationId: number; id: number },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteRule>>,
  TError,
  { oktaUserId: string; modelId: number; calculationId: number; id: number },
  TContext
> => {
  const mutationKey = ['deleteRule'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteRule>>,
    { oktaUserId: string; modelId: number; calculationId: number; id: number }
  > = (props) => {
    const { oktaUserId, modelId, calculationId, id } = props ?? {};

    return deleteRule(oktaUserId, modelId, calculationId, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteRule>>
>;

export type DeleteRuleMutationError = ErrorType<unknown>;

/**
 * @summary Delete rule
 */
export const useDeleteRule = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteRule>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        calculationId: number;
        id: number;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteRule>>,
  TError,
  { oktaUserId: string; modelId: number; calculationId: number; id: number },
  TContext
> => {
  return useMutation(getDeleteRuleMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns calculation for the aid model
 * @summary Get calculation
 */
export const getCalculation = (
  oktaUserId: string,
  modelId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelCalculationDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/calculations`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetCalculationQueryKey = (
  oktaUserId: string,
  modelId: number
) => {
  return [`/api/${oktaUserId}/aid-models/${modelId}/calculations`] as const;
};

export const getGetCalculationQueryOptions = <
  TData = Awaited<ReturnType<typeof getCalculation>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalculation>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCalculationQueryKey(oktaUserId, modelId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCalculation>>> = ({
    signal,
  }) => getCalculation(oktaUserId, modelId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && modelId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCalculation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCalculationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCalculation>>
>;
export type GetCalculationQueryError = ErrorType<unknown>;

export function useGetCalculation<
  TData = Awaited<ReturnType<typeof getCalculation>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalculation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalculation>>,
          TError,
          Awaited<ReturnType<typeof getCalculation>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalculation<
  TData = Awaited<ReturnType<typeof getCalculation>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalculation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCalculation>>,
          TError,
          Awaited<ReturnType<typeof getCalculation>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCalculation<
  TData = Awaited<ReturnType<typeof getCalculation>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalculation>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get calculation
 */

export function useGetCalculation<
  TData = Awaited<ReturnType<typeof getCalculation>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCalculation>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCalculationQueryOptions(
    oktaUserId,
    modelId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Creates a new calculation for the aid model
 * @summary Create calculation
 */
export const createCalculation = (
  oktaUserId: string,
  modelId: number,
  aidModelCalculationRequest: BodyType<AidModelCalculationRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<AidModelCalculationDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/calculations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: aidModelCalculationRequest,
      signal,
    },
    options
  );
};

export const getCreateCalculationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCalculation>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<AidModelCalculationRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCalculation>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<AidModelCalculationRequest>;
  },
  TContext
> => {
  const mutationKey = ['createCalculation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCalculation>>,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<AidModelCalculationRequest>;
    }
  > = (props) => {
    const { oktaUserId, modelId, data } = props ?? {};

    return createCalculation(oktaUserId, modelId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCalculationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCalculation>>
>;
export type CreateCalculationMutationBody =
  BodyType<AidModelCalculationRequest>;
export type CreateCalculationMutationError = ErrorType<unknown>;

/**
 * @summary Create calculation
 */
export const useCreateCalculation = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCalculation>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        data: BodyType<AidModelCalculationRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCalculation>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<AidModelCalculationRequest>;
  },
  TContext
> => {
  return useMutation(getCreateCalculationMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Adds a new rule to the calculation
 * @summary Add rule
 */
export const addRule = (
  oktaUserId: string,
  modelId: number,
  id: number,
  calculationRuleRequest: BodyType<CalculationRuleRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CalculationRuleDto>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/calculations/${id}/rules`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: calculationRuleRequest,
      signal,
    },
    options
  );
};

export const getAddRuleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addRule>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      id: number;
      data: BodyType<CalculationRuleRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addRule>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    id: number;
    data: BodyType<CalculationRuleRequest>;
  },
  TContext
> => {
  const mutationKey = ['addRule'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addRule>>,
    {
      oktaUserId: string;
      modelId: number;
      id: number;
      data: BodyType<CalculationRuleRequest>;
    }
  > = (props) => {
    const { oktaUserId, modelId, id, data } = props ?? {};

    return addRule(oktaUserId, modelId, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof addRule>>
>;
export type AddRuleMutationBody = BodyType<CalculationRuleRequest>;
export type AddRuleMutationError = ErrorType<unknown>;

/**
 * @summary Add rule
 */
export const useAddRule = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addRule>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        id: number;
        data: BodyType<CalculationRuleRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addRule>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    id: number;
    data: BodyType<CalculationRuleRequest>;
  },
  TContext
> => {
  return useMutation(getAddRuleMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Splits the submitted CEEB codes into those present in and absent from the model's student dataset
 * @summary Validate CEEB codes
 */
export const validateCeebCodes = (
  oktaUserId: string,
  modelId: number,
  ceebCodesValidationRequest: BodyType<CeebCodesValidationRequest>,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CeebCodesValidationResponse>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/calculations/ceeb-codes/validations`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: ceebCodesValidationRequest,
      signal,
    },
    options
  );
};

export const getValidateCeebCodesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof validateCeebCodes>>,
    TError,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<CeebCodesValidationRequest>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customAxios>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof validateCeebCodes>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<CeebCodesValidationRequest>;
  },
  TContext
> => {
  const mutationKey = ['validateCeebCodes'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validateCeebCodes>>,
    {
      oktaUserId: string;
      modelId: number;
      data: BodyType<CeebCodesValidationRequest>;
    }
  > = (props) => {
    const { oktaUserId, modelId, data } = props ?? {};

    return validateCeebCodes(oktaUserId, modelId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ValidateCeebCodesMutationResult = NonNullable<
  Awaited<ReturnType<typeof validateCeebCodes>>
>;
export type ValidateCeebCodesMutationBody =
  BodyType<CeebCodesValidationRequest>;
export type ValidateCeebCodesMutationError = ErrorType<unknown>;

/**
 * @summary Validate CEEB codes
 */
export const useValidateCeebCodes = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof validateCeebCodes>>,
      TError,
      {
        oktaUserId: string;
        modelId: number;
        data: BodyType<CeebCodesValidationRequest>;
      },
      TContext
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof validateCeebCodes>>,
  TError,
  {
    oktaUserId: string;
    modelId: number;
    data: BodyType<CeebCodesValidationRequest>;
  },
  TContext
> => {
  return useMutation(getValidateCeebCodesMutationOptions(options), queryClient);
};
/**
 * Authorities: **ROLE_SUPER_ADMIN, ROLE_FD_PRINCIPAL, ROLE_FD_ANALYST, ROLE_REPORT_ADMIN, ROLE_USER, ROLE_INTERNAL_USER**<br /><br />Returns all rules for the calculation
 * @summary Get rules
 */
export const getRules = (
  oktaUserId: string,
  modelId: number,
  calculationId: number,
  options?: SecondParameter<typeof customAxios>,
  signal?: AbortSignal
) => {
  return customAxios<CalculationRuleDto[]>(
    {
      url: `/api/${oktaUserId}/aid-models/${modelId}/calculations/${calculationId}/rules`,
      method: 'GET',
      signal,
    },
    options
  );
};

export const getGetRulesQueryKey = (
  oktaUserId: string,
  modelId: number,
  calculationId: number
) => {
  return [
    `/api/${oktaUserId}/aid-models/${modelId}/calculations/${calculationId}/rules`,
  ] as const;
};

export const getGetRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRules>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  calculationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetRulesQueryKey(oktaUserId, modelId, calculationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRules>>> = ({
    signal,
  }) => getRules(oktaUserId, modelId, calculationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(oktaUserId && modelId && calculationId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRules>>
>;
export type GetRulesQueryError = ErrorType<unknown>;

export function useGetRules<
  TData = Awaited<ReturnType<typeof getRules>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  calculationId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRules>>,
          TError,
          Awaited<ReturnType<typeof getRules>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRules<
  TData = Awaited<ReturnType<typeof getRules>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  calculationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRules>>,
          TError,
          Awaited<ReturnType<typeof getRules>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetRules<
  TData = Awaited<ReturnType<typeof getRules>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  calculationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get rules
 */

export function useGetRules<
  TData = Awaited<ReturnType<typeof getRules>>,
  TError = ErrorType<unknown>
>(
  oktaUserId: string,
  modelId: number,
  calculationId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRules>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxios>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetRulesQueryOptions(
    oktaUserId,
    modelId,
    calculationId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
